import { render } from "./FormTransferenciaResponsavel.vue?vue&type=template&id=2293d43c"
import script from "./FormTransferenciaResponsavel.vue?vue&type=script&lang=js"
export * from "./FormTransferenciaResponsavel.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FormularioTransferenciaDeResponsavel/FormTransferenciaResponsavel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2293d43c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2293d43c', __exports__)) {
    console.log('reload')
    api.reload('2293d43c', __exports__)
  }
  
  module.hot.accept("./FormTransferenciaResponsavel.vue?vue&type=template&id=2293d43c", () => {
    console.log('re-render')
    api.rerender('2293d43c', render)
  })

}


export default __exports__